import * as tslib_1 from "tslib";
import { Report } from './../../_models/carts-orders';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Router } from '@angular/router';
var DashService = /** @class */ (function () {
    function DashService(http, apollo, router) {
        this.http = http;
        this.apollo = apollo;
        this.router = router;
        this.reportDataNew = new Report();
        this.reportData = new Report();
        this.token = localStorage.getItem('token');
    }
    /// GET ALL REPORTS
    DashService.prototype.getAllReportsDataZa = function (reportData) {
        this.token = localStorage.getItem('token');
        var allReportGQL = gql;
        var q = '';
        q = "query { OrderReportsByDay (\n                shopNo: " + reportData.shopNo + ",\n                limit: " + reportData.limit + ",\n                skip: " + reportData.skip + ",\n                sort: {dateCreated: 1},\n                dateFrom: \"" + reportData.dateFrom + "\",\n                dateTo: \"" + reportData.dateTo + "\" )\n                {\n                  totals {\n                    orderCount\n                    orderTotal\n                    orderAverage\n                  }\n                  ordersByDate {\n                    vendorDoesOwnShipping\n                    dateCreated\n                    value\n                    shippingAmount\n                    discount\n                  }\n                }\n              }";
        allReportGQL = gql(q);
        return this.apollo.query({
            query: allReportGQL,
            variables: {
                dateFrom: reportData.dateFrom,
                limit: reportData.limit,
                skip: reportData.skip,
                dateTo: reportData.dateTo,
                shopNo: reportData.shopNo
            },
            fetchPolicy: 'network-only',
            context: {
                headers: new HttpHeaders().set('x-access-token', this.token)
            }
        }).pipe(map(function (newdata) {
            var userInfo = newdata;
            // console.log(userInfo);
            localStorage.setItem('OrderReports', JSON.stringify(userInfo.data));
            return userInfo.data;
        }));
    };
    DashService.prototype.getAllReportsDataUk = function (reportData) {
        this.token = localStorage.getItem('token');
        var allReportGQL = gql;
        var q = '';
        q = "query { OrderReportsByDay (\n                  shopNo: " + reportData.shopNo + ",\n                  limit: " + reportData.limit + ",\n                  skip: " + reportData.skip + ",\n                  sort: {dateCreated: 1},\n                  dateFrom: \"" + reportData.dateFrom + "\",\n                  dateTo: \"" + reportData.dateTo + "\")\n                  {\n                    totals {\n                      orderCount\n                      orderTotal\n                      orderAverage\n                    }\n                    ordersByDate {\n                      vendorDoesOwnShipping\n                      dateCreated\n                      value\n                      shippingAmount\n                      discount\n                    }\n                  }\n                }";
        allReportGQL = gql(q);
        return this.apollo.query({
            query: allReportGQL,
            variables: {
                dateFrom: reportData.dateFrom,
                limit: reportData.limit,
                skip: reportData.skip,
                dateTo: reportData.dateTo,
                shopNo: reportData.shopNo
            },
            fetchPolicy: 'network-only',
            context: {
                headers: new HttpHeaders().set('x-access-token', this.token)
            }
        }).pipe(map(function (newdata) {
            var userInfo = newdata;
            // console.log(userInfo);
            localStorage.setItem('OrderReportsUk', JSON.stringify(userInfo.data));
            return userInfo.data;
        }));
    };
    ///
    DashService.prototype.getOrderShipmentStats = function (reportData) {
        this.token = localStorage.getItem('token');
        var allReportGQL = gql;
        var q = '';
        q = "query { OrderShipmentStats (\n                  shopNo: " + reportData.shopNo + ",\n                  dateFrom: \"" + reportData.dateFrom + "\",\n                  dateTo: \"" + reportData.dateTo + "\")\n                  {\n                    pendingStats\n                    deliveredStats\n                    canceledStats\n                    processing\n                    outForDelivery\n                    newCustomers\n                    returningCustomers\n                    allItemslisted\n                    topRatedItemsListed\n                    newItemsListed\n                    totalShipmentsCount\n                    totalPayedForShipmentsCount\n                    totalDelayedShipmentsCount\n                    totalOrdersCount\n                    totalPayedForOrders\n                    totalDelayedOrders\n                    itemStockCount\n                    suppliersActiveCount\n                  }\n                }";
        allReportGQL = gql(q);
        return this.apollo.query({
            query: allReportGQL,
            variables: {
                dateFrom: reportData.dateFrom,
                limit: reportData.limit,
                skip: reportData.skip,
                dateTo: reportData.dateTo,
                shopNo: reportData.shopNo
            },
            fetchPolicy: 'network-only',
            context: {
                headers: new HttpHeaders().set('x-access-token', this.token)
            }
        }).pipe(map(function (newdata) {
            var userInfo = newdata;
            localStorage.setItem('OrderShipmentStats', JSON.stringify(userInfo.data));
            return userInfo.data;
        }));
    };
    ////
    DashService.prototype.getDashStats = function (reportData) {
        // console.log(reportData);
        var OrderShipmentStatsGQL = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query OrderShipmentStats ($shopNo: Int, $dateFrom:String, $dateTo:String){\n        OrderShipmentStats(shopNo: $shopNo, dateFrom:$dateFrom, dateTo:$dateTo){\n          pendingStats\n                    deliveredStats\n                    canceledStats\n                    processing\n                    outForDelivery\n                    newCustomers\n                    returningCustomers\n                    allItemslisted\n                    topRatedItemsListed\n                    newItemsListed\n                    totalShipmentsCount\n                    totalPayedForShipmentsCount\n                    totalDelayedShipmentsCount\n                    totalOrdersCount\n                    totalPayedForOrders\n                    totalDelayedOrders\n                    itemStockCount\n  \t                suppliersActiveCount\n        }\n        ItemUploadStats(shopNo: $shopNo, dateFrom:$dateFrom, dateTo:$dateTo){\n          count\n          message\n        }\n      }\n    "], ["\n      query OrderShipmentStats ($shopNo: Int, $dateFrom:String, $dateTo:String){\n        OrderShipmentStats(shopNo: $shopNo, dateFrom:$dateFrom, dateTo:$dateTo){\n          pendingStats\n                    deliveredStats\n                    canceledStats\n                    processing\n                    outForDelivery\n                    newCustomers\n                    returningCustomers\n                    allItemslisted\n                    topRatedItemsListed\n                    newItemsListed\n                    totalShipmentsCount\n                    totalPayedForShipmentsCount\n                    totalDelayedShipmentsCount\n                    totalOrdersCount\n                    totalPayedForOrders\n                    totalDelayedOrders\n                    itemStockCount\n  \t                suppliersActiveCount\n        }\n        ItemUploadStats(shopNo: $shopNo, dateFrom:$dateFrom, dateTo:$dateTo){\n          count\n          message\n        }\n      }\n    "])));
        return this.apollo.query({
            context: {
                headers: new HttpHeaders().set('x-access-token', this.token)
            },
            query: OrderShipmentStatsGQL,
            variables: {
                dateFrom: reportData.dateFrom,
                dateTo: reportData.dateTo,
                shopNo: reportData.shopNo
            }
        })
            .pipe(map(function (newdata) {
            var userInfo = newdata;
            localStorage.setItem('OrderShipmentStats', JSON.stringify(userInfo.data));
            return userInfo.data;
        }));
    };
    ////
    DashService.prototype.OrderBasedOnItemDetailReport = function (reportData) {
        this.token = localStorage.getItem('token');
        var allReportGQL = gql;
        var q = '';
        q = "query { OrderBasedOnItemDetailReport (\n                  shopNo: " + reportData.shopNo + ",\n                  itemDetailTypeNo: " + reportData.itemDetailTypeNo + "\n                  dateFrom: \"" + reportData.dateFrom + "\",\n                  dateTo: \"" + reportData.dateTo + "\",sort: \"quantity\", sortOrder: \"desc\")\n                  {\n                    quantity\n                    description\n                  }\n                }";
        allReportGQL = gql(q);
        return this.apollo.query({
            query: allReportGQL,
            variables: {
                dateFrom: reportData.dateFrom,
                dateTo: reportData.dateTo,
                shopNo: reportData.shopNo
            },
            fetchPolicy: 'network-only',
            context: {
                headers: new HttpHeaders().set('x-access-token', this.token)
            }
        }).pipe(map(function (newdata) {
            var userInfo = newdata;
            localStorage.setItem('OrderBasedOnItemDetailReport' + reportData.shopNo, JSON.stringify(userInfo.data));
            return userInfo.data;
        }));
    };
    ///
    DashService.prototype.UserStat = function (reportData) {
        this.token = localStorage.getItem('token');
        var allReportGQL = gql;
        var q = '';
        q = "query { UserStat (\n                  dateFrom: \"" + reportData.dateFrom + "\",\n                  dateTo: \"" + reportData.dateTo + "\")\n                  {\n                    newCustomersCountZA\n                    newCustomersCountUK\n                  }\n                }";
        allReportGQL = gql(q);
        return this.apollo.query({
            query: allReportGQL,
            variables: {
                dateFrom: reportData.dateFrom,
                dateTo: reportData.dateTo
            },
            fetchPolicy: 'network-only',
            context: {
                headers: new HttpHeaders().set('x-access-token', this.token)
            }
        }).pipe(map(function (newdata) {
            var userInfo = newdata;
            // console.log(newdata);
            localStorage.setItem('UserStat', JSON.stringify(userInfo.data));
            return userInfo.data;
        }));
    };
    ///
    DashService.prototype.UserLoggedIn = function () {
        this.token = localStorage.getItem('token');
        var allReportGQL = gql;
        var q = '';
        q = "query { UserTokenStats\n                  {\n                    customerUsersLoggedIn\n                    shopUsersLoggedIn\n                    supplierUsersLoggedIn\n                    adminUsersLoggedIn\n                  }\n                }";
        allReportGQL = gql(q);
        return this.apollo.query({
            query: allReportGQL,
            fetchPolicy: 'network-only',
            context: {
                headers: new HttpHeaders().set('x-access-token', this.token)
            }
        }).pipe(map(function (newdata) {
            var userInfo = newdata;
            // console.log(newdata);
            localStorage.setItem('UserTokenStats', JSON.stringify(userInfo.data));
            return userInfo.data;
        }));
    };
    return DashService;
}());
export { DashService };
var templateObject_1;
